module.exports = __webpack_public_path__ + "static/media/9DESA21.9721cf0d.jpg";